<template>
  <v-card :loading="loadingCard" :disabled="loadingCard">
    <v-card-title>
      <v-row justify="space-between">
        <span class="font-weight-light" style="font-size: 16pt">{{ $t('label.evaluation') }}</span>
        <v-btn icon @click.stop="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row justify="center">
        <span style="font-size: 14pt; margin-top: 5px">1</span>
        <v-icon v-for="(star, i) in stars" :key="i" size="23pt" v-text="getIcon(star)" color="primary" :title="i + 1"></v-icon>
        <span style="font-size: 14pt; margin-top: 5px">10</span>
      </v-row>
      <br>
      <v-row>
        <v-col cols="12">
            <v-textarea
              v-model="evaluation.comments"
              readonly
              :label="$t('label.comments')"
              rows="4"
              outlined
              dense>
            </v-textarea>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn small depressed @click.stop="close" :disabled="loadingCard">{{ $t('label.close') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { showMessage } from '../../../mixins'

export default {
  name: 'AuctionEvaluation',
  props: {
    auctionId: Number,
    isActive: Boolean
  },
  mixins: [showMessage],
  data: () => ({
    evaluation: {
      comments: '',
      score: 0
    },
    stars: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    loadingCard: false,
    auction: {}
  }),
  methods: {
    getAuction () {
      this.loadingCard = true
      this.$proxy.get(`api/auctions/${this.auctionId}`)
        .then((r) => {
          this.auction = r.data
          if (this.auction.auctionEvaluationControl) {
            this.evaluation.comments = this.auction.auctionEvaluationControl.comments
            this.selectStar(this.auction.auctionEvaluationControl.score - 1)
          }
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.loadingCard = false
        })
    },
    close () {
      this.evaluation = {
        comments: '',
        score: 0
      }
      this.stars = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      this.$emit('close')
    },
    selectStar (index) {
      this.evaluation.score = index + 1
      this.stars = this.stars.map((s, i) => {
        if (i <= index) {
          return 1
        } else {
          return 0
        }
      })
    },
    getIcon (starValue) {
      if (starValue === 1) {
        return 'mdi-star'
      } else {
        return 'mdi-star-outline'
      }
    }
  },
  watch: {
    auctionId: function (newVal, oldVal) {
      if (!this.isActive) {
        return
      }
      if (newVal) {
        this.auction = []
        this.getAuction()
      }
    }
  },
  mounted () {
    this.getAuction()
  }
}
</script>

<style>

</style>
